import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "left-bracket",
  "use": "left-bracket-usage",
  "viewBox": "0 0 19 30",
  "content": "<symbol viewBox=\"0 0 19 30\" xmlns=\"http://www.w3.org/2000/svg\" id=\"left-bracket\"><path d=\"M19 0H9.994C4.477 0 0 4.477 0 10v10c0 5.525 4.474 10 9.994 10H19c-5.354-2.863-8.996-8.505-8.996-15 0-6.494 3.642-12.137 8.996-15z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/svg/left-bracket.svg
// module id = 591
// module chunks = 0